import { render, staticRenderFns } from "./addwidgets.vue?vue&type=template&id=83754254&"
import script from "./addwidgets.vue?vue&type=script&lang=js&"
export * from "./addwidgets.vue?vue&type=script&lang=js&"
import style0 from "./addwidgets.vue?vue&type=style&index=0&id=83754254&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports